import React from "react";

import { Button } from "src/app/components/Button/Button";
import { ReactComponent as ThunderIcon } from "src/images/thunder.svg";
import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";

export default function CreateAudienceButton({ createAudience }) {
  return (
    <Button
      size="medium"
      variant="white"
      onClick={createAudience}
      data-qa="create-audience-button"
    >
      <ThunderIcon className="icon-left" />
      <IDHFormattedMessage
        id="front_create_audience"
        defaultMessage="Create Audience"
      />
    </Button>
  );
}
